import RowGrowAllCode from "!!raw-loader!./gridrows/RowGrowAll";
import RowSpacingCode from "!!raw-loader!./gridrows/RowSpacing";
import RowWrapCode from "!!raw-loader!./gridrows/RowWrap";
import RowNoWrapCode from "!!raw-loader!./gridrows/RowNoWrap";
import RowChildGrowCode from "!!raw-loader!./gridrows/RowChildGrow";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import RowGrowAll from "./gridrows/RowGrowAll";
import RowSpacing from "./gridrows/RowSpacing";
import RowChildGrow from "./gridrows/RowChildGrow";
import RowWrap from "./gridrows/RowWrap";
import RowNoWrap from "./gridrows/RowNoWrap";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Growing first child, then second child", RowChildGrowCode, RowChildGrow),
		paneComponent("Wrap Example for noWrap property", RowWrapCode, RowWrap),
		paneComponent("No Wrap Example for noWrap property", RowNoWrapCode, RowNoWrap),
		paneComponent("Growing all children", RowGrowAllCode, RowGrowAll),
		paneComponent("Spacing between children", RowSpacingCode, RowSpacing),
	];

	return (
		<Pane
			components={components}
			{...props} 
		/>
	);
};